import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import RatingDetailComp from "../../components/RatingDetailComp";
import { AppContext } from "../../contexts/AppContext";

const RatingDetail: React.FC = () => {
  const { findAndSetStore } = useContext(AppContext);
  const { storeId } = useParams<{ storeId: string }>();
  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  return <RatingDetailComp />;
};

export default RatingDetail;
